import * as React from "react";
import styles from "./error_page.module.sass";

type RetryButtonProps = {
  onRetry: () => void;
};

export const RetryButton = ({ onRetry }: RetryButtonProps) => (
  <button className="button btn-large button-primary " onClick={onRetry}>
    Načíst znovu
  </button>
);
